// source: pbtypes/gen/telit_lte_modem/cellular_modem_state.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_cellular_sim_configs_sim_config_pb = require('../../../pbtypes/gen/cellular_sim_configs/sim_config_pb.js');
goog.object.extend(proto, pbtypes_gen_cellular_sim_configs_sim_config_pb);
var pbtypes_gen_cellular_sim_configs_sim_slot_pb = require('../../../pbtypes/gen/cellular_sim_configs/sim_slot_pb.js');
goog.object.extend(proto, pbtypes_gen_cellular_sim_configs_sim_slot_pb);
var pbtypes_gen_streaming_bitrate_controller_link_type_pb = require('../../../pbtypes/gen/streaming_bitrate_controller/link_type_pb.js');
goog.object.extend(proto, pbtypes_gen_streaming_bitrate_controller_link_type_pb);
var pbtypes_gen_telit_lte_modem_deployment_mode_pb = require('../../../pbtypes/gen/telit_lte_modem/deployment_mode_pb.js');
goog.object.extend(proto, pbtypes_gen_telit_lte_modem_deployment_mode_pb);
var pbtypes_gen_telit_lte_modem_modem_power_state_pb = require('../../../pbtypes/gen/telit_lte_modem/modem_power_state_pb.js');
goog.object.extend(proto, pbtypes_gen_telit_lte_modem_modem_power_state_pb);
var pbtypes_gen_telit_lte_modem_modem_type_pb = require('../../../pbtypes/gen/telit_lte_modem/modem_type_pb.js');
goog.object.extend(proto, pbtypes_gen_telit_lte_modem_modem_type_pb);
var pbtypes_gen_telit_lte_modem_modem_version_status_pb = require('../../../pbtypes/gen/telit_lte_modem/modem_version_status_pb.js');
goog.object.extend(proto, pbtypes_gen_telit_lte_modem_modem_version_status_pb);
var pbtypes_gen_telit_lte_modem_telit_fault_pb = require('../../../pbtypes/gen/telit_lte_modem/telit_fault_pb.js');
goog.object.extend(proto, pbtypes_gen_telit_lte_modem_telit_fault_pb);
goog.exportSymbol('proto.telit_lte_modem.CellularModemState', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.telit_lte_modem.CellularModemState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.telit_lte_modem.CellularModemState.repeatedFields_, null);
};
goog.inherits(proto.telit_lte_modem.CellularModemState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.telit_lte_modem.CellularModemState.displayName = 'proto.telit_lte_modem.CellularModemState';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.telit_lte_modem.CellularModemState.repeatedFields_ = [21,23];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.telit_lte_modem.CellularModemState.prototype.toObject = function(opt_includeInstance) {
  return proto.telit_lte_modem.CellularModemState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telit_lte_modem.CellularModemState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.telit_lte_modem.CellularModemState.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
modemType: jspb.Message.getFieldWithDefault(msg, 2, 0),
iccid: jspb.Message.getFieldWithDefault(msg, 3, ""),
imei: jspb.Message.getFieldWithDefault(msg, 4, ""),
sourceLink: jspb.Message.getFieldWithDefault(msg, 5, 0),
registered: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
deploymentMode: jspb.Message.getFieldWithDefault(msg, 7, 0),
networkOperator: jspb.Message.getFieldWithDefault(msg, 8, ""),
powerState: jspb.Message.getFieldWithDefault(msg, 9, 0),
estimatedUplinkThroughputBps: jspb.Message.getFieldWithDefault(msg, 10, 0),
primaryBand: jspb.Message.getFieldWithDefault(msg, 11, 0),
primaryBandwidthMhz: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
primaryRsrpDbm: jspb.Message.getFieldWithDefault(msg, 13, 0),
primaryRsrqDb: jspb.Message.getFieldWithDefault(msg, 14, 0),
primarySignalQuality: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
simConfig: (f = msg.getSimConfig()) && pbtypes_gen_cellular_sim_configs_sim_config_pb.SimConfig.toObject(includeInstance, f),
imsi: jspb.Message.getFieldWithDefault(msg, 17, ""),
gsn: jspb.Message.getFieldWithDefault(msg, 18, ""),
attachmentSerial: jspb.Message.getFieldWithDefault(msg, 19, ""),
selectedSimIndex: jspb.Message.getFieldWithDefault(msg, 20, 0),
simSlotsList: jspb.Message.toObjectList(msg.getSimSlotsList(),
    pbtypes_gen_cellular_sim_configs_sim_slot_pb.SimSlot.toObject, includeInstance),
swpkgv: jspb.Message.getFieldWithDefault(msg, 22, ""),
telitFaultsList: jspb.Message.toObjectList(msg.getTelitFaultsList(),
    pbtypes_gen_telit_lte_modem_telit_fault_pb.TelitFault.toObject, includeInstance),
networkMnc: jspb.Message.getFieldWithDefault(msg, 24, ""),
networkMcc: jspb.Message.getFieldWithDefault(msg, 25, ""),
modemVersionStatus: (f = msg.getModemVersionStatus()) && pbtypes_gen_telit_lte_modem_modem_version_status_pb.ModemVersionStatus.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telit_lte_modem.CellularModemState}
 */
proto.telit_lte_modem.CellularModemState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.telit_lte_modem.CellularModemState;
  return proto.telit_lte_modem.CellularModemState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telit_lte_modem.CellularModemState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telit_lte_modem.CellularModemState}
 */
proto.telit_lte_modem.CellularModemState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setUtime(value);
      break;
    case 2:
      var value = /** @type {!proto.telit_lte_modem.ModemType.Enum} */ (reader.readEnum());
      msg.setModemType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setIccid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setImei(value);
      break;
    case 5:
      var value = /** @type {!proto.streaming_bitrate_controller.LinkType.Enum} */ (reader.readEnum());
      msg.setSourceLink(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRegistered(value);
      break;
    case 7:
      var value = /** @type {!proto.telit_lte_modem.DeploymentMode.Enum} */ (reader.readEnum());
      msg.setDeploymentMode(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNetworkOperator(value);
      break;
    case 9:
      var value = /** @type {!proto.telit_lte_modem.ModemPowerState.Enum} */ (reader.readEnum());
      msg.setPowerState(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setEstimatedUplinkThroughputBps(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setPrimaryBand(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPrimaryBandwidthMhz(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setPrimaryRsrpDbm(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setPrimaryRsrqDb(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPrimarySignalQuality(value);
      break;
    case 16:
      var value = new pbtypes_gen_cellular_sim_configs_sim_config_pb.SimConfig;
      reader.readMessage(value,pbtypes_gen_cellular_sim_configs_sim_config_pb.SimConfig.deserializeBinaryFromReader);
      msg.setSimConfig(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setImsi(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setGsn(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setAttachmentSerial(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setSelectedSimIndex(value);
      break;
    case 21:
      var value = new pbtypes_gen_cellular_sim_configs_sim_slot_pb.SimSlot;
      reader.readMessage(value,pbtypes_gen_cellular_sim_configs_sim_slot_pb.SimSlot.deserializeBinaryFromReader);
      msg.addSimSlots(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setSwpkgv(value);
      break;
    case 23:
      var value = new pbtypes_gen_telit_lte_modem_telit_fault_pb.TelitFault;
      reader.readMessage(value,pbtypes_gen_telit_lte_modem_telit_fault_pb.TelitFault.deserializeBinaryFromReader);
      msg.addTelitFaults(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNetworkMnc(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setNetworkMcc(value);
      break;
    case 26:
      var value = new pbtypes_gen_telit_lte_modem_modem_version_status_pb.ModemVersionStatus;
      reader.readMessage(value,pbtypes_gen_telit_lte_modem_modem_version_status_pb.ModemVersionStatus.deserializeBinaryFromReader);
      msg.setModemVersionStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.telit_lte_modem.CellularModemState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.telit_lte_modem.CellularModemState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telit_lte_modem.CellularModemState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.telit_lte_modem.CellularModemState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeSint64(
      1,
      f
    );
  }
  f = message.getModemType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getIccid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getImei();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSourceLink();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getRegistered();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getDeploymentMode();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getNetworkOperator();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPowerState();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getEstimatedUplinkThroughputBps();
  if (f !== 0) {
    writer.writeSint64(
      10,
      f
    );
  }
  f = message.getPrimaryBand();
  if (f !== 0) {
    writer.writeSint32(
      11,
      f
    );
  }
  f = message.getPrimaryBandwidthMhz();
  if (f !== 0.0) {
    writer.writeFloat(
      12,
      f
    );
  }
  f = message.getPrimaryRsrpDbm();
  if (f !== 0) {
    writer.writeSint32(
      13,
      f
    );
  }
  f = message.getPrimaryRsrqDb();
  if (f !== 0) {
    writer.writeSint32(
      14,
      f
    );
  }
  f = message.getPrimarySignalQuality();
  if (f !== 0.0) {
    writer.writeFloat(
      15,
      f
    );
  }
  f = message.getSimConfig();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      pbtypes_gen_cellular_sim_configs_sim_config_pb.SimConfig.serializeBinaryToWriter
    );
  }
  f = message.getImsi();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getGsn();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getAttachmentSerial();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getSelectedSimIndex();
  if (f !== 0) {
    writer.writeSint32(
      20,
      f
    );
  }
  f = message.getSimSlotsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      21,
      f,
      pbtypes_gen_cellular_sim_configs_sim_slot_pb.SimSlot.serializeBinaryToWriter
    );
  }
  f = message.getSwpkgv();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getTelitFaultsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      23,
      f,
      pbtypes_gen_telit_lte_modem_telit_fault_pb.TelitFault.serializeBinaryToWriter
    );
  }
  f = message.getNetworkMnc();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getNetworkMcc();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getModemVersionStatus();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      pbtypes_gen_telit_lte_modem_modem_version_status_pb.ModemVersionStatus.serializeBinaryToWriter
    );
  }
};


/**
 * optional sint64 utime = 1;
 * @return {number}
 */
proto.telit_lte_modem.CellularModemState.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.telit_lte_modem.CellularModemState} returns this
 */
proto.telit_lte_modem.CellularModemState.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional ModemType.Enum modem_type = 2;
 * @return {!proto.telit_lte_modem.ModemType.Enum}
 */
proto.telit_lte_modem.CellularModemState.prototype.getModemType = function() {
  return /** @type {!proto.telit_lte_modem.ModemType.Enum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.telit_lte_modem.ModemType.Enum} value
 * @return {!proto.telit_lte_modem.CellularModemState} returns this
 */
proto.telit_lte_modem.CellularModemState.prototype.setModemType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string iccid = 3;
 * @return {string}
 */
proto.telit_lte_modem.CellularModemState.prototype.getIccid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.telit_lte_modem.CellularModemState} returns this
 */
proto.telit_lte_modem.CellularModemState.prototype.setIccid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string imei = 4;
 * @return {string}
 */
proto.telit_lte_modem.CellularModemState.prototype.getImei = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.telit_lte_modem.CellularModemState} returns this
 */
proto.telit_lte_modem.CellularModemState.prototype.setImei = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional streaming_bitrate_controller.LinkType.Enum source_link = 5;
 * @return {!proto.streaming_bitrate_controller.LinkType.Enum}
 */
proto.telit_lte_modem.CellularModemState.prototype.getSourceLink = function() {
  return /** @type {!proto.streaming_bitrate_controller.LinkType.Enum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.streaming_bitrate_controller.LinkType.Enum} value
 * @return {!proto.telit_lte_modem.CellularModemState} returns this
 */
proto.telit_lte_modem.CellularModemState.prototype.setSourceLink = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional bool registered = 6;
 * @return {boolean}
 */
proto.telit_lte_modem.CellularModemState.prototype.getRegistered = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.telit_lte_modem.CellularModemState} returns this
 */
proto.telit_lte_modem.CellularModemState.prototype.setRegistered = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional DeploymentMode.Enum deployment_mode = 7;
 * @return {!proto.telit_lte_modem.DeploymentMode.Enum}
 */
proto.telit_lte_modem.CellularModemState.prototype.getDeploymentMode = function() {
  return /** @type {!proto.telit_lte_modem.DeploymentMode.Enum} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.telit_lte_modem.DeploymentMode.Enum} value
 * @return {!proto.telit_lte_modem.CellularModemState} returns this
 */
proto.telit_lte_modem.CellularModemState.prototype.setDeploymentMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional string network_operator = 8;
 * @return {string}
 */
proto.telit_lte_modem.CellularModemState.prototype.getNetworkOperator = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.telit_lte_modem.CellularModemState} returns this
 */
proto.telit_lte_modem.CellularModemState.prototype.setNetworkOperator = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional ModemPowerState.Enum power_state = 9;
 * @return {!proto.telit_lte_modem.ModemPowerState.Enum}
 */
proto.telit_lte_modem.CellularModemState.prototype.getPowerState = function() {
  return /** @type {!proto.telit_lte_modem.ModemPowerState.Enum} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.telit_lte_modem.ModemPowerState.Enum} value
 * @return {!proto.telit_lte_modem.CellularModemState} returns this
 */
proto.telit_lte_modem.CellularModemState.prototype.setPowerState = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional sint64 estimated_uplink_throughput_bps = 10;
 * @return {number}
 */
proto.telit_lte_modem.CellularModemState.prototype.getEstimatedUplinkThroughputBps = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.telit_lte_modem.CellularModemState} returns this
 */
proto.telit_lte_modem.CellularModemState.prototype.setEstimatedUplinkThroughputBps = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional sint32 primary_band = 11;
 * @return {number}
 */
proto.telit_lte_modem.CellularModemState.prototype.getPrimaryBand = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.telit_lte_modem.CellularModemState} returns this
 */
proto.telit_lte_modem.CellularModemState.prototype.setPrimaryBand = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional float primary_bandwidth_mhz = 12;
 * @return {number}
 */
proto.telit_lte_modem.CellularModemState.prototype.getPrimaryBandwidthMhz = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.telit_lte_modem.CellularModemState} returns this
 */
proto.telit_lte_modem.CellularModemState.prototype.setPrimaryBandwidthMhz = function(value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional sint32 primary_rsrp_dbm = 13;
 * @return {number}
 */
proto.telit_lte_modem.CellularModemState.prototype.getPrimaryRsrpDbm = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.telit_lte_modem.CellularModemState} returns this
 */
proto.telit_lte_modem.CellularModemState.prototype.setPrimaryRsrpDbm = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional sint32 primary_rsrq_db = 14;
 * @return {number}
 */
proto.telit_lte_modem.CellularModemState.prototype.getPrimaryRsrqDb = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.telit_lte_modem.CellularModemState} returns this
 */
proto.telit_lte_modem.CellularModemState.prototype.setPrimaryRsrqDb = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional float primary_signal_quality = 15;
 * @return {number}
 */
proto.telit_lte_modem.CellularModemState.prototype.getPrimarySignalQuality = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.telit_lte_modem.CellularModemState} returns this
 */
proto.telit_lte_modem.CellularModemState.prototype.setPrimarySignalQuality = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional cellular_sim_configs.SimConfig sim_config = 16;
 * @return {?proto.cellular_sim_configs.SimConfig}
 */
proto.telit_lte_modem.CellularModemState.prototype.getSimConfig = function() {
  return /** @type{?proto.cellular_sim_configs.SimConfig} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_cellular_sim_configs_sim_config_pb.SimConfig, 16));
};


/**
 * @param {?proto.cellular_sim_configs.SimConfig|undefined} value
 * @return {!proto.telit_lte_modem.CellularModemState} returns this
*/
proto.telit_lte_modem.CellularModemState.prototype.setSimConfig = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.telit_lte_modem.CellularModemState} returns this
 */
proto.telit_lte_modem.CellularModemState.prototype.clearSimConfig = function() {
  return this.setSimConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.telit_lte_modem.CellularModemState.prototype.hasSimConfig = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional string imsi = 17;
 * @return {string}
 */
proto.telit_lte_modem.CellularModemState.prototype.getImsi = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.telit_lte_modem.CellularModemState} returns this
 */
proto.telit_lte_modem.CellularModemState.prototype.setImsi = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string gsn = 18;
 * @return {string}
 */
proto.telit_lte_modem.CellularModemState.prototype.getGsn = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.telit_lte_modem.CellularModemState} returns this
 */
proto.telit_lte_modem.CellularModemState.prototype.setGsn = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string attachment_serial = 19;
 * @return {string}
 */
proto.telit_lte_modem.CellularModemState.prototype.getAttachmentSerial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.telit_lte_modem.CellularModemState} returns this
 */
proto.telit_lte_modem.CellularModemState.prototype.setAttachmentSerial = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional sint32 selected_sim_index = 20;
 * @return {number}
 */
proto.telit_lte_modem.CellularModemState.prototype.getSelectedSimIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.telit_lte_modem.CellularModemState} returns this
 */
proto.telit_lte_modem.CellularModemState.prototype.setSelectedSimIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * repeated cellular_sim_configs.SimSlot sim_slots = 21;
 * @return {!Array<!proto.cellular_sim_configs.SimSlot>}
 */
proto.telit_lte_modem.CellularModemState.prototype.getSimSlotsList = function() {
  return /** @type{!Array<!proto.cellular_sim_configs.SimSlot>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_cellular_sim_configs_sim_slot_pb.SimSlot, 21));
};


/**
 * @param {!Array<!proto.cellular_sim_configs.SimSlot>} value
 * @return {!proto.telit_lte_modem.CellularModemState} returns this
*/
proto.telit_lte_modem.CellularModemState.prototype.setSimSlotsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 21, value);
};


/**
 * @param {!proto.cellular_sim_configs.SimSlot=} opt_value
 * @param {number=} opt_index
 * @return {!proto.cellular_sim_configs.SimSlot}
 */
proto.telit_lte_modem.CellularModemState.prototype.addSimSlots = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 21, opt_value, proto.cellular_sim_configs.SimSlot, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.telit_lte_modem.CellularModemState} returns this
 */
proto.telit_lte_modem.CellularModemState.prototype.clearSimSlotsList = function() {
  return this.setSimSlotsList([]);
};


/**
 * optional string swpkgv = 22;
 * @return {string}
 */
proto.telit_lte_modem.CellularModemState.prototype.getSwpkgv = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.telit_lte_modem.CellularModemState} returns this
 */
proto.telit_lte_modem.CellularModemState.prototype.setSwpkgv = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * repeated TelitFault telit_faults = 23;
 * @return {!Array<!proto.telit_lte_modem.TelitFault>}
 */
proto.telit_lte_modem.CellularModemState.prototype.getTelitFaultsList = function() {
  return /** @type{!Array<!proto.telit_lte_modem.TelitFault>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_telit_lte_modem_telit_fault_pb.TelitFault, 23));
};


/**
 * @param {!Array<!proto.telit_lte_modem.TelitFault>} value
 * @return {!proto.telit_lte_modem.CellularModemState} returns this
*/
proto.telit_lte_modem.CellularModemState.prototype.setTelitFaultsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 23, value);
};


/**
 * @param {!proto.telit_lte_modem.TelitFault=} opt_value
 * @param {number=} opt_index
 * @return {!proto.telit_lte_modem.TelitFault}
 */
proto.telit_lte_modem.CellularModemState.prototype.addTelitFaults = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 23, opt_value, proto.telit_lte_modem.TelitFault, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.telit_lte_modem.CellularModemState} returns this
 */
proto.telit_lte_modem.CellularModemState.prototype.clearTelitFaultsList = function() {
  return this.setTelitFaultsList([]);
};


/**
 * optional string network_mnc = 24;
 * @return {string}
 */
proto.telit_lte_modem.CellularModemState.prototype.getNetworkMnc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.telit_lte_modem.CellularModemState} returns this
 */
proto.telit_lte_modem.CellularModemState.prototype.setNetworkMnc = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string network_mcc = 25;
 * @return {string}
 */
proto.telit_lte_modem.CellularModemState.prototype.getNetworkMcc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.telit_lte_modem.CellularModemState} returns this
 */
proto.telit_lte_modem.CellularModemState.prototype.setNetworkMcc = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional ModemVersionStatus modem_version_status = 26;
 * @return {?proto.telit_lte_modem.ModemVersionStatus}
 */
proto.telit_lte_modem.CellularModemState.prototype.getModemVersionStatus = function() {
  return /** @type{?proto.telit_lte_modem.ModemVersionStatus} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_telit_lte_modem_modem_version_status_pb.ModemVersionStatus, 26));
};


/**
 * @param {?proto.telit_lte_modem.ModemVersionStatus|undefined} value
 * @return {!proto.telit_lte_modem.CellularModemState} returns this
*/
proto.telit_lte_modem.CellularModemState.prototype.setModemVersionStatus = function(value) {
  return jspb.Message.setWrapperField(this, 26, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.telit_lte_modem.CellularModemState} returns this
 */
proto.telit_lte_modem.CellularModemState.prototype.clearModemVersionStatus = function() {
  return this.setModemVersionStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.telit_lte_modem.CellularModemState.prototype.hasModemVersionStatus = function() {
  return jspb.Message.getField(this, 26) != null;
};


goog.object.extend(exports, proto.telit_lte_modem);
